import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ViewChildren, ElementRef, QueryList } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PetFullReferModel } from "../../../models/pet-full-refer.model";
import { ActivatedRoute, ParamMap } from '@angular/router';
import { PetService } from '../../../services/pet.service';
import { ManagerialService } from '../../../services/managerial.service';
import Swal from 'sweetalert2';
declare var $: any;

@Component({
  selector: 'ngx-work-checkin',
  templateUrl: './check-in.component.html',
})
export class CheckInComponent implements OnInit {
  u_password = ''
  u_emailadd = ''
  private _pet_no: number;

  @Input() set pet_no(value: number) {
    this._pet_no = value;
    this.petService.getPetCheckIn(this.pet_no).then(() => { });
  }

  get pet_no(): number {
    return this._pet_no;
  }

  constructor(
    public petService: PetService,
    public managerialService: ManagerialService,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit() {
    this.petService.changePet
      .subscribe(message => {
        if (message !== this.pet_no) {
          this.pet_no = message;
        }
      });
  }

  save() {
    Swal.fire({
      title: 'Loading...',
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading()
      },
    })

    this.petService.setupPetCheckIn()
      .then(() => {
        const pet_no = this.petService.current_pet_no;

        // Refresh the work header (weight/temp/BCS badges with their 24h colors, doctor, nurse)
        return Promise.all([
          this.petService.GetPetProfileLastEntry(pet_no),
          this.petService.GetPetVisit(pet_no),
          this.petService.getPetExtraData(pet_no),
        ]);
      })
      .then(() => {
        Swal.close();

        Swal.fire({
          title: 'Information stored correctly',
        })
      });
  }

  open() {
    $('#modalCheckRefer').modal({ backdrop: 'static', keyboard: false }) 
    $('#modalCheckRefer').modal('show')
  }

  refer() { 
    let by_doctor = this.petService.pet_refer_by.refer_doctor
    let by_hospital = this.petService.pet_refer_by.refer_hospital
    let by_date = this.petService.pet_refer_by.refer_date

    this.petService.pet_fullrefer = new PetFullReferModel(this.pet_no,by_doctor,by_hospital,by_date,this.petService.pet_refer.refer_doctor,this.petService.pet_refer.refer_hospital,this.petService.getCurrentDate())
    this.petService.setupPetRefer().then(() => {
       $('#modalCheckRefer').modal('hide')
       Swal.fire({
          title: 'Saved Successfully',
          didOpen: () => {
          },
      }) 
    })
  }

  enterPass(){

  }

  openStatModal(type){
    this.petService.profile_type = type
    this.petService.notify_PetStatFunction();
  } 

  openDoctorNurseModal(){
    this.petService.notify_DrNurseFunction();
  }
}
